<template>
    <div class="d-flex">
        <img :src="product.images[0]" class="image-item mr-2" />
        <div class="align-self-center flex-grow-1">
            <p class="mb-0">SKU: {{ product.sku }}</p>
        </div>
        <div>
            {{ step }} {{ $t('labels.of') }} {{ totalSteps }}
        </div>
    </div>
    <NavTab class="nav-tabs-bottom">
        <NavTabItem v-for="language in languages" :href="`#language-${language}`" :ref="setTabRef">{{ $t(`languages.${language}`) }}</NavTabItem>
        <template #content>
            <NavTabPane v-for="(language, index) in languages" :id="`language-${language}`">
                <div class="row">
                    <div class="col-lg-6">
                        <FormGroup :label="`${$t('labels.name')} (${ $t('aiGeneration.review.old') })`" v-if="productBody.hasOwnProperty('names') && isFieldForAdaptation('names')">
                            <Input :model-value="product.names?.[language]" disabled/>
                        </FormGroup>
                    </div>
                    <div class="col-lg-6">
                        <FormGroup :label="`${$t('labels.name')} (${ $t('aiGeneration.review.new') })`" v-if="productBody.hasOwnProperty('names') && isFieldForAdaptation('names')">
                            <Input :model-value="productBody.names?.[language]" @update:model-value="productBody.names[language] = $event" />
                        </FormGroup>
                    </div>
                    <div class="col-lg-6">
                        <FormGroup :label="`${$t('labels.description')} (${ $t('aiGeneration.review.old') })`" v-if="productBody.hasOwnProperty('descriptions') && isFieldForAdaptation('descriptions')">
                            <InputTextArea :model-value="product.descriptions?.[language]" disabled/>
                        </FormGroup>
                    </div>
                    <div class="col-lg-6">
                        <FormGroup :label="`${$t('labels.description')} (${ $t('aiGeneration.review.new') })`" v-if="productBody.hasOwnProperty('descriptions') && isFieldForAdaptation('descriptions')">
                            <InputTextArea :model-value="productBody.descriptions?.[language]" @update:model-value="productBody.descriptions[language] = $event" />
                        </FormGroup>
                    </div>
                    <div class="col-lg-6">
                        <FormGroup :label="`${$t('labels.seo')} (${ $t('aiGeneration.review.old') })`" v-if="productBody.hasOwnProperty('seos') && isFieldForAdaptation('seos')">
                            <Tags :model-value="product.seo?.[language]" disabled/>
                        </FormGroup>
                    </div>
                    <div class="col-lg-6">
                        <FormGroup :label="`${$t('labels.seo')} (${ $t('aiGeneration.review.new') })`" v-if="productBody.hasOwnProperty('seos') && isFieldForAdaptation('seos')">
                            <Tags :model-value="productBody.seos?.[language]" @update:model-value="productBody.seos[language] = $event" />
                        </FormGroup>
                    </div>
                </div>
            </NavTabPane>
        </template>
    </NavTab>
</template>
<script>
import FormGroup from '../../../../../components/new/form/group/FormGroup.vue';
import Input from '../../../../../components/new/form/Input.vue';
import NavTab from '../../../../components/tabs/NavTab.vue';
import NavTabItem from '../../../../components/tabs/NavTabItem.vue';
import NavTabPane from '../../../../components/tabs/NavTabPane.vue';
import InputTextArea from '../../../../../components/new/form/InputTextArea.vue';
import Tags from '../../../../../components/new/form/Tags.vue';

export default {
    name: "GeneratedContentFields",
    components: {
        FormGroup, Input, NavTab, NavTabItem, NavTabPane, InputTextArea, Tags
    },
    props: {
        languages: {
            type: Array,
            required: true
        },
        productBody: {
            type: Object,
            required: true
        },
        product: {
            type: Object,
            required: true
        },
        step: {
            type: Number,
            required: true
        },
        totalSteps: {
            type: Number,
            required: false
        },
        fieldsForUpdate: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            tabRefs: [],
        }
    },
    methods: {
        setTabRef(el) {
            if (el) {
                this.tabRefs.push(el);
            }
        },
        isFieldForAdaptation(fieldKey) {
            const field = this.fieldsForUpdate.find(f => f.key === fieldKey);
            return field && field.aiAdaptation;
        }
    },
    beforeUpdate() {
        this.tabRefs = []
    },
    mounted() {
        this.$nextTick(() => {
            this.tabRefs[0].click()
        });
    }
}
</script>
<style scoped>
.image-item {
    width: 38px;
    height: 38px;
    object-fit: cover;
}
</style>